import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { getSMEDetails, SMEDetailsResponseModel } from "@tCentro/Services/CENSMEDetailsService";

export interface GetSMEDetailsParameter extends HasOnSuccess<SMEDetailsResponseModel>, HasOnError<string> {
    smeid: string;
}

type HandlerType = ApiHandler<GetSMEDetailsParameter, { apiResult: SMEDetailsResponseModel }>;

export const GetSMEDetails: HandlerType = async props => {
    try {
        const result = await getSMEDetails({ smeid: props.parameter.smeid });
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to load employee details");
        }
    }
};

export const chain = [GetSMEDetails];
const getSMEDetailsData = createHandlerChainRunner(chain, "getSMEDetailsData");
export default getSMEDetailsData;
